<template>
  <div class="about">
    <aside class="profile">
      <img
        src="https://hyunwook.s3.us-east-2.amazonaws.com/images/profile3.jpg"
        class="profile__photo"
        alt="Hyunwook Shin">
      <h2 class="profile__name">Hyunwook Shin</h2>
      <p class="profile__role">Software Engineer · Bay Area</p>
      <div class="profile__links">
        <a href="https://github.com/hyunwookshin" class="pill">GitHub</a>
        <a href="https://www.linkedin.com/in/hwshin/" class="pill">LinkedIn</a>
        <a href="https://medium.com/@shincontact" class="pill">Medium</a>
      </div>
    </aside>

    <div class="about__body">
      <div v-if="error" class="about__state">
        Couldn't load this section right now.
        <button type="button" class="about__retry" @click="load">Try again</button>
      </div>
      <template v-else-if="items">
        <section v-for="item in items" :key="item.title" class="about__section">
          <h2 class="about__title">{{ item.title }}</h2>
          <p class="about__text">{{ item.content }}</p>
        </section>
      </template>
      <section v-else class="about__section about__section--skeleton" aria-hidden="true">
        <span class="bar bar--lg"></span>
        <span class="bar"></span>
        <span class="bar"></span>
        <span class="bar bar--sm"></span>
      </section>
    </div>
  </div>
</template>

<script>
import { getSection } from '../api'

export default {
  name: 'AboutPage',
  props: {
    page: { type: Object, required: true }
  },
  data() {
    return {
      items: null,
      error: false
    }
  },
  methods: {
    load() {
      this.error = false
      getSection(this.page.section)
        .then(items => {
          this.items = items
        })
        .catch(error => {
          // eslint-disable-next-line
          console.error(error)
          this.error = true
        })
    }
  },
  created() {
    this.load()
  }
}
</script>

<style scoped>
.about {
  display: grid;
  grid-template-columns: 300px 1fr;
  gap: 24px;
  align-items: start;
}

/* ── Profile card ───────────────────────────────────── */
.profile {
  position: sticky;
  top: 88px;
  padding: 32px 24px;
  border: 1px solid var(--line);
  border-radius: var(--radius);
  background-color: var(--surface);
  box-shadow: var(--shadow-sm);
  text-align: center;
}
.profile__photo {
  width: 128px;
  height: 128px;
  object-fit: cover;
  border-radius: 50%;
  padding: 4px;
  background: linear-gradient(135deg, var(--accent), var(--accent-2));
}
.profile__name {
  margin: 18px 0 4px;
  font-size: 1.25rem;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: var(--text);
}
.profile__role {
  margin: 0 0 20px;
  font-size: 0.9rem;
  color: var(--text-subtle);
}
.profile__links {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px;
}
.pill {
  padding: 6px 14px;
  border-radius: 999px;
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--accent) !important;
  background-color: var(--accent-soft);
  transition: background-color 0.15s, color 0.15s;
}
.pill:hover {
  color: #fff !important;
  background-color: var(--accent);
}

/* ── Body ───────────────────────────────────────────── */
.about__body {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.about__section,
.about__state {
  padding: 32px 36px;
  border: 1px solid var(--line);
  border-radius: var(--radius);
  background-color: var(--surface);
  box-shadow: var(--shadow-sm);
}
.about__state {
  color: var(--text-muted);
}
.about__retry {
  margin-left: 8px;
  padding: 4px 14px;
  border: 1px solid var(--line);
  border-radius: 999px;
  background-color: var(--surface);
  font-weight: 600;
  color: var(--accent);
}
.about__title {
  margin: 0 0 14px;
  font-size: 1.3rem;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: var(--text);
}
.about__text {
  margin: 0;
  font-size: 1rem;
  line-height: 1.8;
  color: var(--text-muted);
  white-space: pre-line;
}

/* ── Skeleton ───────────────────────────────────────── */
.bar {
  display: block;
  height: 12px;
  margin-bottom: 12px;
  border-radius: 6px;
  background: linear-gradient(90deg, #eef1f6 25%, #f6f8fb 50%, #eef1f6 75%);
  background-size: 200% 100%;
  animation: shimmer 1.4s ease-in-out infinite;
}
.bar--sm {
  width: 40%;
}
.bar--lg {
  height: 20px;
  width: 35%;
  margin-bottom: 20px;
}
@keyframes shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

@media (max-width: 760px) {
  .about {
    grid-template-columns: 1fr;
  }
  .profile {
    position: static;
  }
  .about__section,
  .about__state {
    padding: 24px 22px;
  }
}
</style>
